import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, watch } from "vue";
import { useDialogStore } from "@/store/dialog";


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalDialog',
  setup(__props) {

const dialogStore = useDialogStore();

const dialog = ref(false);
const title = ref("");
const message = ref("");
const type = ref<"alert" | "confirm">("alert");

// ストアの状態を監視してダイアログを表示
watch(
  () => dialogStore.isOpen,
  (newValue) => {
    dialog.value = newValue;
    if (newValue) {
      title.value = dialogStore.title;
      message.value = dialogStore.message;
      type.value = dialogStore.type;
    }
  }
);

function handleConfirm() {
  dialogStore.confirm();
}

function handleCancel() {
  dialogStore.cancel();
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    "max-width": "500",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(title.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(message.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              (type.value === 'confirm')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "grey-darken-1",
                    variant: "text",
                    onClick: handleCancel
                  }, {
                    default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                      _createTextVNode(" キャンセル ", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "text",
                onClick: handleConfirm
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" OK ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})